module.exports = __webpack_public_path__ + "img/8354120.png";